export enum ButtonStyleType {
    FILL = "button-fill",
    OUTLINE = "button-outline"
}

export enum TextSize {
    SMALL = "text-small",
    MEDIUM = "text-medium",
    LARGE = "text-large"
}

export enum MediaButtonType {
    PLAY = 'play_arrow',
    PAUSE = 'pause',
    STOP = 'stop',
}

export interface ButtonProps {
    callback?: () => void,
    styleType: ButtonStyleType
}

